import clsx from 'clsx';

type PhValue = 4.5 | 5.0 | 5.5 | 6.0 | 6.5 | 7.0;

interface PhSelectorProps {
  value?: PhValue;
  onChange: (v: PhValue) => void;
}

const SCALE: Array<{
  value: PhValue;
  label: string;
  bg: string;
  text: string;
  hint: string;
}> = [
  { value: 4.5, label: 'pH 4.5', bg: '#D2691E', text: '#FFFFFF', hint: 'Muy ácido' },
  { value: 5.0, label: 'pH 5.0', bg: '#E8843F', text: '#FFFFFF', hint: 'Ácido' },
  { value: 5.5, label: 'pH 5.5', bg: '#E9C46A', text: '#1A1A1A', hint: 'Ácido normal' },
  { value: 6.0, label: 'pH 6.0', bg: '#A8C77A', text: '#1A1A1A', hint: 'Neutro' },
  { value: 6.5, label: 'pH 6.5', bg: '#5E8C53', text: '#FFFFFF', hint: 'Lig. alcalino' },
  { value: 7.0, label: 'pH 7.0+', bg: '#3A6B7C', text: '#FFFFFF', hint: 'Alcalino' },
];

export default function PhSelector({ value, onChange }: PhSelectorProps) {
  const hasSelection = value != null;

  return (
    <div className="grid grid-cols-3 md:grid-cols-6 gap-4 pt-3 px-2 pb-2">
      {SCALE.map((s) => {
        const active = value === s.value;
        return (
          <button
            key={s.value}
            type="button"
            onClick={() => onChange(s.value)}
            className={clsx(
              'relative rounded-xl2 transition-all duration-200 p-4 min-h-[120px]',
              'flex flex-col items-center justify-center gap-2',
              'focus:outline-none',
              active
                ? 'ring-2 ring-elixir-gold ring-offset-2 ring-offset-elixir-black shadow-[0_8px_24px_-10px_rgba(201,169,97,0.45)]'
                : hasSelection
                ? 'opacity-55 hover:opacity-95'
                : 'hover:ring-2 hover:ring-elixir-gold/40'
            )}
            style={{ backgroundColor: s.bg }}
          >
            {/* Check badge cuando está activo */}
            {active && (
              <span className="absolute -top-3 -right-3 w-9 h-9 rounded-full bg-elixir-gold text-elixir-black flex items-center justify-center shadow-lg">
                <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
                  <path
                    d="M3.5 9.5 L7 13 L14.5 5"
                    stroke="currentColor"
                    strokeWidth="2.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </span>
            )}

            <span className="font-semibold text-base" style={{ color: s.text }}>
              {s.label}
            </span>
            <span className="text-xs leading-tight" style={{ color: s.text, opacity: 0.85 }}>
              {s.hint}
            </span>
          </button>
        );
      })}
    </div>
  );
}
